import React from 'react'
import { Table } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import { FormattedDate } from '../../components/FormattedDate'

class ItemListTable extends React.Component {
  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        width: 10,
        sorter: true,
      }, {
        title: 'Order',
        dataIndex: 'order',
        key: 'order',
      }, {
        title: 'From Year',
        dataIndex: 'fromYear',
        key: 'fromYear',
        render: text => <FormattedDate yearOnly text={text} />,
      }, {
        title: 'To Year',
        dataIndex: 'toYear',
        key: 'toYear',
        render: text => <FormattedDate yearOnly text={text} />,
      }, {
        title: 'Data',
        dataIndex: 'data',
        key: 'data',
      }, {
        title: 'Created At',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        render: text => <FormattedDate text={text} />,
      }, {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 100,
        render: (text, record) => (
          <span>
            <TableRowEditButton to={`${this.props.editPath}/${record.id}`} />
          </span>
        ),
      },
    ]
    return (
      <Table
        rowKey={record => `item-row-${record.id}`}
        columns={columns}
        size='small'
        scroll={{ x: 900 }}
        {...this.props}
      />
    )
  }
}

export default ItemListTable
